import { useMemo } from "react";

import { type Conversation } from "shared/apiClient";
import { getText, type Noticeboard } from "shared/lib";

import { useGetReportContent } from "shared/hooks";
import { ProgressIndicatorListStatus } from "shared/components";

const getStaticConfig = () => {
  return [
    {
      status: ProgressIndicatorListStatus.none,
      text: getText("Assessing the land use against your zone requirements"),
      icon: "🔍",
    },
    {
      status: ProgressIndicatorListStatus.none,
      text: getText(
        "Reviewing buildings and works conditions against overlay legislation",
      ),
      icon: "🚧",
    },
    {
      status: ProgressIndicatorListStatus.none,
      text: getText("Evaluating potential impacts to vegetation"),
      icon: "🌳",
    },
    {
      status: ProgressIndicatorListStatus.none,
      text: getText("Summarising findings"),
      icon: "📝",
    },
  ];
};

export function useGetReportLoadingIndicatorConfig(
  conversation: Conversation | undefined | null,
  noticeboardData: Noticeboard | undefined | null,
) {
  const { getConfigs } = useGetReportContent({
    conversation,
    noticeboardData,
  });

  const expertConfigs = useMemo(() => {
    return getConfigs(`enquiry.report_loading_indicator`);
  }, [getConfigs]);

  const staticConfigs = useMemo(() => {
    return getStaticConfig();
  }, []);

  return expertConfigs.reduce((memo, expertConfig, index) => {
    const staticConfig = staticConfigs[index];

    memo[expertConfig.expert_name] = {
      status: staticConfig.status,
      text: staticConfig.text,
      icon: staticConfig.icon,
    };

    return memo;
  }, {});
}
